require([
    "jquery",
    "utilities",
    "logging",
    "storage"
], function ($, utilities, logging, storage) {
    "use strict";
    var _ModuleName = "Main App";
    
    var _config = {
        bundles: {
            coreg: {
                components: [ "gdpr-redirect", "coreg", "conversion-tracker", "path-tracker", "skip-button-support" ],
                data: { }
            },
            regpath: {
                components: [ "gdpr-redirect", "regpath-landing", "auto-field-fill", "conversion-tracker", "path-tracker", "skip-button-support" ],
                data: {
                    disableRadioAutoFill: true
                }
            },
            signup: {
                components: [ "v2-process-support", "gdpr-redirect", "regpath-offer", "mobile-optimize-fields", "auto-field-fill", "conversion-tracker", "path-tracker" ],
                data: { 
                    signup: true
                }
            },
            initialsignup: {
                components: [ "v2-process-support", "gdpr-redirect", "signup", "mobile-optimize-fields", "auto-field-fill", "conversion-tracker", "path-tracker" ],
                data: { 
                    signup: true
                }
            },
            fullpageoffer: {
                components: [ "v2-process-support", "full-page-offer", "mobile-optimize-fields", "auto-field-fill", "conversion-tracker", "path-tracker", "skip-button-support" ]
            },
            fullpageoffermultistep: {
                components: [ "v2-process-support", "multi-step", "full-page-offer", "mobile-optimize-fields", "auto-field-fill", "conversion-tracker", "path-tracker", "skip-button-support" ],
                data: {
                    isMultiStep: true
                }
            },
            fullpageoffernoform: {
                components: [ "v2-process-support", "full-page-offer", "skip-button-support" ],
                data: {
                    verifyFormExists: false
                }
            },
            thankyoupage: {
                components: [ "v2-process-support", "automated-lead-processor" ]
            },
            test: {
                components: [ "path-tracker" ],
                data: { 
                    signup: true
                }
            }
        }
    };

    // Initialize storage 
    storage.init();

    // Initialize utilities
    utilities.init();

    function init(config) {
        if(config.component) {
            // If component is an array, use it.
            // If compoentn is a comma delimited string, break it up into an array
            var components = Array.isArray(config.component) 
                ? config.component
                : ((config.component.indexOf(',') < 0) ? [ config.component ] : components.split(','));

            // If bundles are enabled, process them
            if(config.enableBundles) {
                logging.debug("Bundles Enabled, processing...", _ModuleName);

                logging.debug("Loading custom bundle defined data", _ModuleName);
                var bundleOpts = _getBundleDefinedData(components);
                Object.assign(config.data, bundleOpts);
                logging.debug("Loaded " + (Object.keys(bundleOpts).length) + " new options to config", _ModuleName);

                logging.debug("Loading custom bundle defined components", _ModuleName);
                components = _processBundles(components);
                logging.debug("Found " + components.length + " to load", _ModuleName);
            }

            logging.debug("Loading components if there are any", _ModuleName);
            for(var i = 0; i < components.length; i++) {
                var c = (components[i]).trim();
                try {
                    logging.debug("Loading Component: " + c, _ModuleName);
                    require(["components/" + c], function( component ) {
                        logging.debug("Initializing Component", _ModuleName);
                        // Initialize 
                        if(component.init && typeof component.init == 'function') {
                            component.init(config.data);
                        }
                        logging.debug("Running component", _ModuleName);
                        // Run
                        if(component.run && typeof component.run == 'function') {
                            if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)
                            ) {
                                component.run();
                            } else {
                              document.addEventListener("DOMContentLoaded", component.run);
                            }
                        }
                    });
                } catch(e) {
                    logging.error("Failed to load component " + c, _ModuleName);
                    logging.error("Message: " + e.message, _ModuleName);
                }
            }
            logging.debug("Component loading setup is complete", _ModuleName);
        }
    }

    function _processBundles(components) {
        var result = [];
        for(var i = 0; i < components.length; i++) {
            if(components[i].indexOf("-bundle") < 0) {
                result.push(components[i]);
                continue;
            }

            var bundle = components[i].replace("-bundle", "").replace(/-/g,"").toLowerCase();
            if(_config.bundles[bundle]) {
                logging.debug("Loading Bundle List for " + components[i], _ModuleName);
                result = result.concat(_config.bundles[bundle].components);
            } else {
                result.push(components[i]);
            }
        }

        logging.debug("Finished processing bundles", _ModuleName);
        return utilities.arrayUnique(result);
    }

    function _getBundleDefinedData(components) {
        var result = {};
        for(var i = 0; i < components.length; i++) {
            if(components[i].indexOf("-bundle") < 0) {
                continue;
            }

            var bundle = components[i].replace("-bundle", "").replace(/-/g,"").toLowerCase();
            if(_config.bundles[bundle]) {
                Object.assign(result, _config.bundles[bundle].data);
            }
        }
        return result;
    }

    window.bnet = window.bnet || { }
    window.bnet.regpath = window.bnet.regpath || {};
    window.bnet.regpath.init = init;
    if(Array.isArray(window.bnet.regpath.queue)) {
        for(var i = 0; i < window.bnet.regpath.queue.length; i++) {
            var x = window.bnet.regpath.queue[i];
			
            if(typeof x == 'function') {
                x();
            }
        }
    }
});
define("main", function(){});

